<template>
	<nk-wrapper spacing="md">
		<nk-row vertical-gutter="2">
			<template v-for="(video, videoIndex) in context.videos" :key="videoIndex">
				<nk-col lg="6/12">
					<nk-card variant="boxed">
						<template #header>
							<nk-title tag="h4" size="md">
								<a
									v-if="video.url"
									:aria-label="`Video öffnen und abspielen`"
									class="cursor-pointer"
									@click="openGallery(videoIndex)"
								>
									<nk-icon icon="video" />
									{{ video.title }}
								</a>
							</nk-title>
						</template>
						<template #body>
							<a
								v-if="video.url"
								class="js-lightbox"
								:href="`${video.url}`"
								:aria-label="`Video öffnen und abspielen`"
							>
								<img :src="video.thumbnail" width="100%" />
							</a>
						</template>
					</nk-card>
				</nk-col>
			</template>
		</nk-row>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {string} context.videos
 */

export default {
	name: 'NkTemplateVideothekWebcontact',

	mixins: [TemplatesDefault],

	mounted() {
		this.glightbox = this.$lightbox({
			selector: '.js-lightbox',
			touchNavigation: true,
			loop: false,
		});
	},

	methods: {
		openGallery(index) {
			this.glightbox.openAt(index);
		},
	},
};
</script>
